<div class="key-metrics-container">

    <div class="metrics-header">
        <h2>Key Metrics</h2>
    </div>

    <div class="metric-list">
        @if (projectSize) {
            <div class="metric">
                <span class="label">Project Size</span>
                <p>{{projectSize}}</p>
            </div>
        }
        @if (servicesList) {
            <div class="metric">
                <span class="label">Services</span>
                @for (service of servicesList; track $index) {
                    <p>{{service}}</p>
                }
            </div>
        }
        @if (clientName) {
            <div class="metric">
                <span class="label">Client</span>
                <p>{{clientName}}</p>
            </div>
        }
        @if (locationName) {
            <div class="metric">
                <span class="label">Location</span>
                <p>{{locationName}}</p>
            </div>
        }
        @if (sector) {
            <div class="metric">
                <span class="label">Sector</span>
                <p>{{sector}}</p>
            </div>
        }
        @if (architectName) {
            <div class="metric">
                <span class="label">Architect</span>
                <p>{{architectName}}</p>
            </div>
        }
        @if (contractorName) {
            <div class="metric">
                <span class="label">Contractor</span>
                <p>{{contractorName}}</p>
        </div>
        }
    </div>
</div>